import { render, staticRenderFns } from "./AddButton.vue?vue&type=template&id=03f7e2f5&scoped=true&"
import script from "./AddButton.vue?vue&type=script&lang=js&"
export * from "./AddButton.vue?vue&type=script&lang=js&"
import style0 from "./AddButton.vue?vue&type=style&index=0&id=03f7e2f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f7e2f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
